import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { sntLog } from "src/app/common/logger";

const beforeUnloadListener = (event: BeforeUnloadEvent) => {
  event.preventDefault();
  return (event.returnValue = "");
};

const logger = sntLog("BeforeUnloadService");

@Injectable()
export class BeforeUnloadService {
  refs: number = 0;

  acquired$: BehaviorSubject<boolean> = new BehaviorSubject(false);

  constructor() {
    (<any>window)["befRefs"] = this;
  }

  isAcquired(): boolean {
    return this.refs > 0;
  }

  async acquire(): Promise<void> {
    logger.debug("acquire");
    if (this.refs === 0) {
      window.addEventListener("beforeunload", beforeUnloadListener, {
        capture: true
      });

      this.acquired$.next(true);
    }

    this.refs++;
  }

  async release(): Promise<void> {
    logger.debug("release");
    if (this.refs === 1) {
      window.removeEventListener("beforeunload", beforeUnloadListener, {
        capture: true
      });

      this.acquired$.next(false);
    }

    this.refs = Math.max(0, this.refs - 1);
  }

  async forceRelease(): Promise<void> {
    logger.debug("forceRelease");

    this.refs = 1;

    await this.release();
  }
}
